import { render, staticRenderFns } from "./rebatey.vue?vue&type=template&id=2ccd0028&scoped=true&"
import script from "./rebatey.vue?vue&type=script&lang=js&"
export * from "./rebatey.vue?vue&type=script&lang=js&"
import style0 from "./rebatey.vue?vue&type=style&index=0&id=2ccd0028&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccd0028",
  null
  
)

export default component.exports